import { ErrorTag, InProgressTag, SuccessTag } from '@lib/common';
import { SubmissionStatusId } from '@module/assignment';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var getTranslatedSubmissionStatusKey = function getTranslatedSubmissionStatusKey(attendee) {
  switch (attendee.report.status.id) {
    case SubmissionStatusId.ONGOING:
      return 'submissionStatusOnGoing';

    case SubmissionStatusId.BANNED:
      return 'submissionStatusBanned';

    case SubmissionStatusId.SUBMITTED:
      {
        var _attendee$report;

        var gradedPercentage = attendee.report.gradedPercentage;

        if (gradedPercentage < 100) {
          return 'submissionStatusSubmitted';
        }

        return (_attendee$report = attendee.report) !== null && _attendee$report !== void 0 && _attendee$report.isSubmissionPassed ? 'submissionStatusPassed' : 'submissionStatusFailed';
      }

    case SubmissionStatusId.NONE:
      {
        return 'submissionStatusNone';
      }

    default:
      {
        return 'None';
      }
  }
};
export var AttendeeSubmissionStatusComponent = function AttendeeSubmissionStatusComponent(_ref) {
  var attendee = _ref.attendee,
      text = _ref.text;

  switch (attendee.report.status.id) {
    case SubmissionStatusId.ONGOING:
      return /*#__PURE__*/_jsx(InProgressTag, {
        children: text
      });

    case SubmissionStatusId.BANNED:
      return /*#__PURE__*/_jsx(ErrorTag, {
        children: text
      });

    case SubmissionStatusId.SUBMITTED:
      {
        var _attendee$report2 = attendee.report,
            isSubmissionPassed = _attendee$report2.isSubmissionPassed,
            gradedPercentage = _attendee$report2.gradedPercentage;

        if (gradedPercentage < 100) {
          return /*#__PURE__*/_jsx(InProgressTag, {
            children: text
          });
        }

        if (isSubmissionPassed === undefined) {
          return /*#__PURE__*/_jsx(InProgressTag, {
            children: text
          });
        }

        return isSubmissionPassed ? /*#__PURE__*/_jsx(SuccessTag, {
          children: text
        }) : /*#__PURE__*/_jsx(ErrorTag, {
          children: text
        });
      }

    case SubmissionStatusId.NONE:
      {
        return /*#__PURE__*/_jsx(ErrorTag, {
          children: "None"
        });
      }

    default:
      {
        return /*#__PURE__*/_jsx(_Fragment, {});
      }
  }
};